import React from "react";
import { EditCountryModal } from "../../Modal/EditCountryModal";

export function CountryEditModal({
  isLoadingEditCountry,
  handleEditHide,
  isEditModal,
  data,
  formik,
  onClickOfSaveButton,
  onClickOfCancelButton,
}) {
  return (
    <>
      <EditCountryModal
        isLoadingEditCountry={isLoadingEditCountry}
        handleEditHide={handleEditHide}
        isEditModal={isEditModal}
        data={data}
        formik={formik}
        onClickOfSaveButton={onClickOfSaveButton}
        onClickOfCancelButton={onClickOfCancelButton}
      />
    </>
  );
}
